import template from './index.jst';
import EmptyPlayerPoolView from "../../../Fantasy/Team/Player/Empty";

export class StatsCentreEmptyPlayerPoolView extends EmptyPlayerPoolView {
	get template(){
		return template;
	}
}

export default StatsCentreEmptyPlayerPoolView;